const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-semibold text-gray-900 mb-8 tracking-tight">
          About
        </h1>
        
        <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
          <p>
            Moss Group is a collaborative studio focused on thoughtful design and intentional making. 
            We work across disciplines to create spaces, systems, and experiences that feel both purposeful and enduring.
          </p>

          <p>
            Our approach is rooted in careful observation, deep listening, and a commitment to quality over speed. 
            We believe the best work emerges when we take time to understand the full context of a project—its history, 
            its people, and its potential.
          </p>

          <h2 className="text-3xl font-semibold text-gray-900 mt-12 mb-6 tracking-tight">
            About This Blog
          </h2>

          <p>
            This blog serves as a space for reflection and dialogue. Here, we share thoughts on our process, 
            insights from ongoing projects, and perspectives on the broader questions that shape our work.
          </p>

          <p>
            We write about design philosophy, creative collaboration, and the values that guide our studio. 
            This isn't a portfolio or a marketing channel—it's a place for honest conversation about what it means 
            to build with care and intention.
          </p>

          <p>
            We hope these writings resonate with others who share a commitment to thoughtful, human-centered work.
          </p>

          <div className="mt-16 pt-8 border-t border-gray-200">
            <p className="text-base text-gray-600">
              For more information about Moss Group and our work, visit{' '}
              <a 
                href="https://mossgroup.org" 
                className="text-gray-900 underline hover:text-gray-600"
                target="_blank"
                rel="noopener noreferrer"
              >
                mossgroup.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
